import { render, staticRenderFns } from "./Child.vue?vue&type=template&id=03a99176&scoped=true&"
import script from "./Child.vue?vue&type=script&lang=js&"
export * from "./Child.vue?vue&type=script&lang=js&"
import style0 from "./Child.vue?vue&type=style&index=0&id=03a99176&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a99176",
  null
  
)

export default component.exports